module.exports = __webpack_public_path__ + "static/media/bookmaker.758ff880.JPG";